import React, { useEffect, useState, useCallback, memo } from 'react';
import Toolbar from 'react-big-calendar/lib/Toolbar';

import Calendar from 'components/general/Calendar';
import { getAppointments } from 'api/appointment';
import { formatAppointmentToCalendar } from 'helpers/format-appointment-to-calendar';

const CalendarPage = () => {
  const [appointments, setAppointments] = useState([]);
  const [selectedMonthLabel, setSelectedMonthLabel] = useState('');

  const fetchAppointments = async (date) => {
    const { data } = await getAppointments(undefined, undefined, date);

    console.log(data.data);

    setAppointments(formatAppointmentToCalendar(data.data));
  };
  const InitialRangeChangeToolbar = memo((props) => {
    const { date, label, view, onView } = props;
    useEffect(() => {
      onView(view);
    }, []);

    // Fetch new appointments only if month has changed
    if (selectedMonthLabel !== label && view === 'month') {
      setSelectedMonthLabel(label);
      fetchAppointments(date);
    }

    return <Toolbar {...props} />;
  });

  return (
    <Calendar
      appointments={appointments}
      components={{ toolbar: InitialRangeChangeToolbar }}
      fetchAppointments={fetchAppointments}
    />
  );
};
export default CalendarPage;
